/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationRecipientPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationRecipientPageResponseOutputItemsItemDisplayNameMax = 250;

export const notificationRecipientPageResponseOutputItemsMax = 100;

export const notificationRecipientPageResponseOutputNextCursorOneMax = 2000;

export const NotificationRecipientPageResponseOutput = zod.object({
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(notificationRecipientPageResponseOutputItemsItemIdRegExp),
        displayName: zod
          .string()
          .max(notificationRecipientPageResponseOutputItemsItemDisplayNameMax),
        role: zod.enum(['Agent', 'Admin']),
        isPolicyTeamMember: zod.boolean(),
      }),
    )
    .max(notificationRecipientPageResponseOutputItemsMax),
  nextCursor: zod.union([
    zod.string().max(notificationRecipientPageResponseOutputNextCursorOneMax),
    zod.null(),
  ]),
});

export type NotificationRecipientPageResponseOutput = zod.input<
  typeof NotificationRecipientPageResponseOutput
>;
export type NotificationRecipientPageResponseOutputOutput = zod.output<
  typeof NotificationRecipientPageResponseOutput
>;
